<div class="row rounded-card" id="notices-settings">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="notices-title">{{ 'SYSTEM_SETTINGS.NOTICES.TITLE' | translate }}</h2>
      <span class="text-base">{{ 'SYSTEM_SETTINGS.NOTICES.SUBTITLE' | translate }}</span>
    </div>

    <div class="flex flex-col items-end gap-2">
      <button type="button" class="btn primary-btn" data-testid="add-notice-btn" [disabled]="loading || openingNoticeModal || savingNotice || updatingNoticeId !== null || allPlacementsAssigned" (click)="openNoticeModalbox()">{{ 'SYSTEM_SETTINGS.NOTICES.BTN_ADD' | translate }}</button>
    </div>
  </div>

  <hr class="mb-1 mt-2 border-t">

  <section>
    @if (!loading && allPlacementsAssigned) {
      <app-notice
        class="col-12 mt-3"
        type="yellow"
        icon="pi pi-exclamation-triangle"
        dataTestId="notices-all-placements-assigned"
        [message]="'SYSTEM_SETTINGS.NOTICES.ALL_PLACEMENTS_ASSIGNED' | translate">
      </app-notice>
    }

    <div class="col-12 mt-4">
      <p-table [value]="paginatedNotices" [loading]="loading">
        <ng-template #header>
          <tr>
            <th>
              <div class="header-wr">
                <span data-testid="brand-name-header" class="col-name">{{ 'SYSTEM_SETTINGS.NOTICES.TH_NAME' | translate }}</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="notice-type-header" class="col-name">{{ 'SYSTEM_SETTINGS.NOTICES.TH_TYPE' | translate }}</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="notice-placement-header" class="col-name">{{ 'SYSTEM_SETTINGS.NOTICES.TH_PLACEMENT' | translate }}</span>
              </div>
            </th>
            <th>
              <div class="header-wr text-center">
                <span data-testid="notices-actions-header" class="col-name w-100">{{ 'SYSTEM_SETTINGS.BRANDS.TH_ACTIONS' | translate }}</span>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template #body let-notice let-rowIndex="rowIndex">
          <tr [attr.data-id]="notice.id">
            <td>
              <span class="p-column-title">{{ 'SYSTEM_SETTINGS.NOTICES.TH_NAME' | translate }}</span>
              <span [attr.data-testid]="'notice-name-' + rowIndex">{{ notice.name | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">{{ 'SYSTEM_SETTINGS.NOTICES.TH_TYPE' | translate }}</span>
              <span [attr.data-testid]="'notice-type-' + rowIndex">{{ getNoticeTypeLabel(notice.type) | translate | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">{{ 'SYSTEM_SETTINGS.NOTICES.TH_PLACEMENT' | translate }}</span>
              <span [attr.data-testid]="'notice-placement-' + rowIndex">{{ getNoticePlacementLabel(notice.placement) | translate | defaultValue }}</span>
            </td>
            <td class="actions-col">
              <span class="p-column-title">{{ 'SYSTEM_SETTINGS.NOTICES.TH_ACTIVE' | translate }}</span>
              <div class="notice-actions">
                <p-toggleswitch [ngModel]="notice.isActive"
                  [disabled]="updatingNoticeId !== null || openingNoticeModal || notice.id == null"
                  [ariaLabel]="'SYSTEM_SETTINGS.NOTICES.TH_ACTIVE' | translate"
                  [attr.data-testid]="'notice-switch-' + rowIndex" (onChange)="onStateChange($event, notice)">
                </p-toggleswitch>
                <button type="button" class="btn-icon-only ui-btn-view btn-icon icon-edit" tooltipPosition="top" [pTooltip]="'SYSTEM_SETTINGS.NOTICES.BTN_EDIT' | translate" [disabled]="openingNoticeModal || updatingNoticeId !== null || notice.id == null" [attr.data-testid]="'edit-notice-' + rowIndex" (click)="openNoticeModalbox(notice.id)">
                  <span class="btn-label">{{ 'SYSTEM_SETTINGS.NOTICES.BTN_EDIT' | translate }}</span>
                </button>
                <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.NOTICES.BTN_DELETE' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-delete btn-icon icon-delete mr-2" (click)="goToDelete($event, notice)" [attr.data-testid]="'btn-delete-' + rowIndex">
                   <span class="btn-label">{{ 'SYSTEM_SETTINGS.NOTICES.BTN_DELETE' | translate }}</span>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="4">{{ 'SYSTEM_SETTINGS.NOTICES.TABLE_NO_DATA' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Pagination -->
      <app-custom-paginator
        data-testid="notices-paginator"
        [first]="paginatorFirst"
        [rows]="paginatorRows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 20, 50]" [showCurrentPageReport]="true"
        [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
        [disabled]="totalRecords === 0 || loading || updatingNoticeId !== null || openingNoticeModal"
        [alwaysShow]="true"
        [showFirstLastIcon]="true"
        [showPageLinks]="true"
        [showPageSizeSelector]="true"
        (onPageChange)="onPageChange($event)">
      </app-custom-paginator>
    </div>
  </section>
</div>

<!-- Modalbox: Create/update notice -->
<p-dialog [(visible)]="showNoticeModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="!savingNotice" [closeOnEscape]="!savingNotice" [dismissableMask]="false" [style]="{ width: '850px', maxWidth: '95vw' }" [header]="(selectedNoticeId !== null ? 'SYSTEM_SETTINGS.NOTICES.BTN_EDIT' : 'SYSTEM_SETTINGS.NOTICES.BTN_ADD') | translate" (onHide)="closeNoticeModalbox()">

  @if (showNoticeModalbox) {
    <form class="mt-0" [formGroup]="noticeForm" (ngSubmit)="saveNotice()">

      <div class="row">
        <div class="field-wr flex flex-col col-12 mb-3">
          <label for="noticeName">
            {{ 'SYSTEM_SETTINGS.NOTICES.TH_NAME' | translate }}
            <i class="icon-required-field"></i>
          </label>

          <input id="noticeName" type="text" autocomplete="off" formControlName="name" />

          @if (noticeForm.get('name')?.invalid && noticeForm.get('name')?.touched) {
          <small class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
          }
        </div>

        <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
          <label>
            {{ 'SYSTEM_SETTINGS.NOTICES.TH_TYPE' | translate }}
            <i class="icon-required-field"></i>
          </label>

          <app-custom-dropdown
            formControlName="type"
            [options]="noticeTypeOptions"
            optionLabel="text"
            optionValue="id"
            [isMultiselect]="false"
            [translateOptionLabel]="true"
            [showSelectionChips]="true"
            [showSearchbox]="false"
            searchMode="local"
            [fieldLabel]="'SYSTEM_SETTINGS.NOTICES.TH_TYPE' | translate"
            [placeholder]="'SYSTEM_SETTINGS.NOTICES.TH_TYPE' | translate">
          </app-custom-dropdown>

          @if (noticeForm.get('type')?.invalid && noticeForm.get('type')?.touched) {
            <small class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
          }
        </div>

        <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
          <label>
            {{ 'SYSTEM_SETTINGS.NOTICES.TH_PLACEMENT' | translate }}
            <i class="icon-required-field"></i>
          </label>

          <app-custom-dropdown
            formControlName="placement"
            [options]="availablePlacementOptions"
            optionLabel="text"
            optionValue="id"
            [isMultiselect]="false"
            [translateOptionLabel]="true"
            [showSelectionChips]="true"
            [showSearchbox]="false"
            searchMode="local"
            [fieldLabel]="'SYSTEM_SETTINGS.NOTICES.TH_PLACEMENT' | translate"
            [placeholder]="'SYSTEM_SETTINGS.NOTICES.TH_PLACEMENT' | translate">
          </app-custom-dropdown>

          @if (noticeForm.get('placement')?.invalid && noticeForm.get('placement')?.touched) {
            <small class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
          }
        </div>

        <div class="col-12">
          <h3 class="border-b pb-1 mt-0">Translations <i class="icon-required-field"></i></h3>

          @if (enabledLanguages.length === 0) {
            <p class="p-error">{{ 'SYSTEM_SETTINGS.NOTICES.NO_ENABLED_LANGUAGES' | translate }}</p>
          } @else {

            <div formArrayName="translations">
              <accordion [multiple]="true" [activeIndex]="[0]" expandIcon="icon-arrow-down" collapseIcon="icon-arrow-up">

                @for (language of enabledLanguages; track language.code; let index = $index) {
                  <accordion-tab [header]="language.name">
                    <div [formGroupName]="index" class="py-3">
                      <!-- WYSIWYG -->
                      <quill-editor
                        formControlName="translation"
                        format="json"
                        theme="snow"
                        [modules]="editorModules"
                        [styles]="{ height: '180px' }"
                        [placeholder]="''">
                      </quill-editor>
                    </div>
                  </accordion-tab>
                }
              </accordion>
            </div>
          }
        </div>
      </div>
    </form>
  }

  <ng-template #footer>
    <button type="button" class="btn outline-btn" [disabled]="savingNotice" (click)="closeNoticeModalbox()">{{ 'SYSTEM_SETTINGS.NOTICES.BTN_CANCEL' | translate }}</button>

    <button type="button" class="btn primary-btn" data-testid="save-notice-btn" [disabled]="noticeForm.invalid || savingNotice || enabledLanguages.length === 0 ||!hasNoticeTranslation" (click)="saveNotice()">{{ 'SYSTEM_SETTINGS.NOTICES.BTN_SAVE' | translate }}</button>
  </ng-template>
</p-dialog>

  <!-- Modalbox: delete -->
  <p-dialog [(visible)]="showDeleteModal" [header]="'SYSTEM_SETTINGS.NOTICES.BTN_DELETE' | translate" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
    <section class="row">
      <div class="col-12">
        <h3 class="pb-3">{{ 'SYSTEM_SETTINGS.NOTICES.MODALBOX_TITLE_DELETE_INFO' | translate }}</h3>
        <h4 class="border-b pb-3">{{ currentNoticeName }}</h4>
      </div>
    </section>
    <ng-template #footer>
      <button data-testid="delete-role-cancel-btn" class="btn outline-btn" (click)="onCancelDelete()">
        {{ 'SYSTEM_SETTINGS.NOTICES.BTN_CANCEL' | translate }}
      </button>
      <button data-testid="delete-role-delete-btn" class="btn primary-btn" (click)="onDelete()">
        {{ 'SYSTEM_SETTINGS.NOTICES.BTN_DELETE' | translate }}
      </button>
    </ng-template>
  </p-dialog>
